import { render, staticRenderFns } from "./roleParam.vue?vue&type=template&id=253bb94f&scoped=true"
import script from "./roleParam.vue?vue&type=script&lang=js"
export * from "./roleParam.vue?vue&type=script&lang=js"
import style0 from "./roleParam.vue?vue&type=style&index=0&id=253bb94f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253bb94f",
  null
  
)

export default component.exports